module.exports = __webpack_public_path__ + "img/pov-brahmino.4a55ddac.png";